import { TermsPage, TermsPageProps } from 'components/pages/terms'
import { publicEnv } from 'env'
import { TermsDocument, TermsQuery } from 'generated/graphql'
import { fetchGraphQL } from 'graphql/request'
import { GetServerSideProps, GetServerSidePropsResult, NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { Routes } from 'routes'

const Page: NextPage<TermsPageProps> = props => {
  return (
    <>
      <NextSeo title="利用規約 | HoteCo" openGraph={{ url: `${publicEnv.host}${Routes.terms()}` }} />
      <TermsPage {...props} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ res }): Promise<GetServerSidePropsResult<TermsPageProps>> => {
  const result = await fetchGraphQL<TermsQuery, never>(TermsDocument)
  res.setHeader('Cache-Control', `public, max-age=60`)
  return { props: { terms: result.terms } }
}

export default Page
